import classNames from 'classnames/bind';

import styles from './S01.module.scss';

import ci from '../../../assets/images/company/pulmuone/s01/ci.jpg';
import bubble_left from '../../../assets/images/company/pulmuone/s01/bubble_left.png';
import bubble_right from '../../../assets/images/company/pulmuone/s01/bubble_right.png';

const cx = classNames.bind(styles);

const S01 = () => {
  return (
    <div className={cx('container')}>
      <div className={cx('limiter')}>
        <img className={cx('left')} src={bubble_left} alt="" />
        <img className={cx('right')} src={bubble_right} alt="" />
        <div className={cx('box')}>
          <div className={cx('grid')}>
            <img className={cx('ci')} src={ci} alt="" />
            <div className={cx('text')}>
              <h3>
                풀무원의 바른먹거리 정신으로
                <br /> 바르게 채우다 ‘풀무원샘물’
              </h3>
              <p>
                풀무원샘물은 1986년 국내 최초로 먹는샘물을 선보인 이후,
                <br /> 풀무원의 바른먹거리 정신을 바탕으로
                <br /> 엄격하고 깐깐한 관리 기준을 물에도 동일하게 적용해 왔습니다.
                <br />
                <br /> 그 기준 아래, 일상에서 안심하고 마실 수 있는 물을 제공하고자 합니다.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default S01;
